export const METADATA = {
  home: {
    title: "Syllepsis | AI Innovation & Knowledge Engineering",
    description: "Syllepsis helps organisations move from AI experiments to sustainable AI capability. We assess where AI creates genuine value, structure the knowledge it needs and build systems that deliver measurable results.",
  },
  services: {
    title: "Syllepsis | Our Services | Knowledge Architecture & AI Solutions",
    description: "An AI innovation and knowledge engineering firm delivering Knowledge Architecture, AI solutions, strategic assessment and capability building. We structure institutional knowledge to create AI systems that compound value over time.",
  },
  aiKickstarter: {
    title: "AI Kickstarter: Structure Your AI Advantage | Syllepsis",
    description: "From experiments to working AI capability in 8 weeks. A focused programme that assesses a target area of your operations, builds the Knowledge Architecture to support it and deploys a working Partner AI - proving value before scaling.",
  },
  knowledgeEngineering: {
    title: "Knowledge Engineering Services | Syllepsis",
    description: "Structure your institutional knowledge for AI consumption. We build knowledge graphs, semantic systems and retrieval architecture - the foundation for AI that genuinely understands your organisation.",
  },
  partnerAI: {
    title: "Partner AI for Your Organisation | Syllepsis",
    description: "A conversational intelligence layer trained on your institutional knowledge. Not a generic chatbot - a knowledgeable partner that understands your terminology, processes and quality standards.",
  },
  operationalAssessment: {
    title: "Operational Assessment | Syllepsis",
    description: "Systematic discovery of current-state challenges with root cause analysis. Understand where you are before transforming where you are going - the foundation for prioritising improvement initiatives.",
  },
  aiOpportunity: {
    title: "AI Opportunity Identification | Syllepsis",
    description: "Cut through the hype. Identify where AI actually creates genuine business value for your organisation, with realistic ROI projections and clear complexity ratings.",
  },
  strategicTransformation: {
    title: "Strategic Transformation Partnerships | Syllepsis",
    description: "Comprehensive AI transformation for organisations wanting deep, lasting change. Embedded partnership that builds enterprise-wide Knowledge Architecture and deploys Partner AI capability tailored to your needs.",
  },
  ourApproach: {
    title: "Syllepsis | Our Approach",
    description: "Syllepsis is an AI innovation and knowledge engineering firm, combining deep consulting expertise with Knowledge Architecture methodology to deliver AI capabilities that work within your specific operational context.",
  },
  meetTheTeam: {
    title: "Syllepsis | Who We Are | Knowledge Engineering & AI Experts",
    description: "Meet the experienced team behind Syllepsis. Our consultants combine deep technical expertise with business acumen to deliver Knowledge Architecture and practical AI solutions.",
  },
  successStories: {
    title: "Syllepsis | Client Success Stories | Measurable AI Implementation Results",
    description: "Real-world client success stories showcasing measurable outcomes from our strategic AI consulting engagements. See how we help organisations achieve rapid results.",
  },
  insights: {
    title: "Syllepsis | AI Insights & Resources | Latest AI Trends & Analysis",
    description: "Explore our latest insights, thought leadership and resources on AI strategy, implementation and innovation. Expert perspectives on practical AI adoption.",
  },
  contact: {
    title: "Syllepsis | Contact Us | Book a Consultation",
    description: "Get in touch with our team of AI consultants. Book a consultation to discuss how we can help accelerate your organisation's AI journey with measurable results.",
  },
  privacy: {
    title: "Syllepsis | Privacy Policy",
    description: "How Syllepsis Ltd collects, uses and protects personal data across our website, survey and diagnostic platform and client engagements, in line with UK data protection law.",
  },
  terms: {
    title: "Syllepsis | Terms of Service",
    description: "The terms governing use of the Syllepsis website and survey and diagnostic platform. Professional engagements are covered by a separate written agreement.",
  }
}
